export type ImportBudgetRequestResponse = {
    items: {
        globalId: string;
        name: string;
        hasErrors: boolean;
        error: string;
    }[],
    requestIsValid: boolean,
    countUpdates: number,
    countAdds: number,
    text: string
};

export type UploadFileResponse = {
    isUploaded: boolean,
    error: string
};

export type GetFilesPayload = {
    plantIds: number[],
    year: number,
    pageNo: number
};

export type GetFilesResponse = {
    files: FileResult[],
    total: number
};

export type FileResult = {
    id?: string,
    miniFdId?: string,
    name: string,
    size?: string,
    extension: string,
    created?: string,
    createdBy?: string,
    fileApplicationType?: string
};

export type DeleteFileResponse = {
    canDelete: boolean,
    error: string
};
